import { Component } from '@angular/core';

@Component({
  selector: 'lib-imprint',
  templateUrl: 'imprint.component.html',
  styleUrls: ['imprint.component.scss']
})
export class ImprintComponent {

  addressTooltip = $localize`Address`;
  telephoneTooltip = $localize`Telephone`;
  faxTooltip = $localize`Fax`;
  emailTooltip = $localize`E-mail`;
  webTooltip = $localize`Web`;
  taxIdTooltip = $localize`Tax ID`;
}
